import {GlobalStyles} from '@mui/material';
import React from 'react';

const globalStyles = () => ({
  'html, body, #root': {
    height: '100%',
    backgroundColor: 'background.paper',
  },
  '#root': {
    display: 'flex',
    flexDirection: 'column',
  },
});

const appGlobalStyles = <GlobalStyles styles={globalStyles} />;

export default appGlobalStyles;
